// Manages: households/{householdId}/budget/txns
import { write } from '@/lib/firebase';

const txnsPath = (householdId) => `households/${householdId}/budget/txns`;

const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

export const transactionService = {
  generateId() {
    return uid();
  },

  async add(householdId, currentTxns, transaction) {
    const tx = { ...transaction, id: transaction.id || uid() };
    await write(txnsPath(householdId), [tx, ...currentTxns]);
  },

  async update(householdId, currentTxns, id, transaction) {
    const updated = currentTxns.map(t => t.id === id ? { ...transaction, id } : t);
    await write(txnsPath(householdId), updated);
  },

  async delete(householdId, currentTxns, id) {
    await write(txnsPath(householdId), currentTxns.filter(t => t.id !== id));
  },

  async split(householdId, currentTxns, id, splits) {
    const original = currentTxns.find(t => t.id === id);
    if (!original) return;
    const splitGroupId = uid();
    const newTxns = splits.map(s => ({
      ...original,
      id: uid(),
      description: original.description + ' (split)',
      amount: s.amount,
      who: s.who,
      splitGroupId,
    }));
    const updated = currentTxns.filter(t => t.id !== id);
    await write(txnsPath(householdId), [...newTxns, ...updated]);
  },

  async deleteSplitGroup(householdId, currentTxns, splitGroupId) {
    await write(txnsPath(householdId), currentTxns.filter(t => t.splitGroupId !== splitGroupId));
  },
};
